/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Language selection" |
*
* @param {Spellcheck_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_language_label = /** @type {((inputs?: Spellcheck_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selection de la langue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprachauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione della lingua")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор языка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de idioma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("语言选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("言語の選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भाषा चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de idioma")
	return /** @type {LocalizedString} */ ("Language selection")
});